
<!-- <app-menu-navbar>
</app-menu-navbar> -->
<div id="loaderOverlay" [ngClass]="!Isdataloaded?'test':'hidden'">
  <div class="loader-overlay">
    <div *ngIf="!Isdataloaded" class="loader"></div>
  </div>
</div>
<div class="search-create-container" style="margin-left: 285px;padding-top:30px;">
  <!-- <h4><i>Search for Survey</i></h4> -->
  <div class="search-create">
   
    <div id="btnAdd" [HideIfUnAuthorized]="'Designer'">
      <app-button [btnText]="" [btnStyle]="btnPlus" [btnType]="btnRnd" [btnColor]="btnColor" [btnSize]="btnLarge" (btnClick)="navigateCreate($event)"></app-button>&nbsp;
    </div>
    &nbsp;&nbsp;
    <div  [HideIfUnAuthorized]="'Designer'" class="header-text">Add a new Survey/Assessment</div>
    &nbsp;&nbsp;
    <div id="search" class="search">
      <app-search-survey></app-search-survey>
    </div>
    
  </div>
</div>
<br />
<div id="navigation-container" class="navigation-container" style="width: 70%;float: right;">
  <div class=column *ngFor="let item of navLinkList" >
  
    <ng-container [ngTemplateOutlet]="nonRespondent">
    </ng-container> 

    <ng-template #nonRespondent >
      <a [HideIfUnAuthorized]="'Respondent'" *ngIf="item.value=='mysurveys'" [routerLink]="item.value" [ngClass]="item.opt?'current-tab':''" (click)="selectedTab(item.key)">{{item.key}}</a>
      <a [HideIfUnAuthorized]="'Designer'" *ngIf="item.value!='mysurveys'" [routerLink]="item.value" [ngClass]="item.opt?'current-tab':''" (click)="selectedTab(item.key)">{{item.key}}</a>
    </ng-template>
  </div>
</div>
<div id="card-container" class="card-container" style="margin-left:30px">
  <br />
  <!-- <router-outlet (Isdataload)="DataLoadStatus($event)"></router-outlet> -->

  <router-outlet ></router-outlet> 
</div>

